import { DataQualification } from '@revenuemarket/trade';
import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export type DataQualificationType = keyof DataQualification;

export interface GetDataQualificationsResponse extends ResponseBaseWithData {
  data: DataQualification;
}

export default function getDataQualifications(companyId: string) {
  return API.get<GetDataQualificationsResponse>(
    `/api/v2/companies/${companyId}/data-qualifications`,
  );
}
